import createIcon from '../../createIcon';

/**
 * @component @name FlightTakeoff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41MjAzNSAxOC43MTVIMjEuNTIwNFYyMC43MTVIMi41MjAzNVYxOC43MTVaTTIyLjA5MDQgOS4zNTUwM0MyMS44ODA0IDguNTU1MDMgMjEuMDUwNCA4LjA3NTAzIDIwLjI1MDQgOC4yOTUwM0wxNC45NDA0IDkuNzE1MDNMOC4wNDAzNSAzLjI4NTAzTDYuMTEwMzUgMy43OTUwM0wxMC4yNTA0IDEwLjk2NUw1LjI4MDM1IDEyLjI5NUwzLjMxMDM1IDEwLjc1NUwxLjg2MDM1IDExLjE0NUw0LjQ1MDM1IDE1LjYzNUM0LjQ1MDM1IDE1LjYzNSAxMS41NzA0IDEzLjczNSAyMS4wMjA0IDExLjIwNUMyMS44MzA0IDEwLjk3NSAyMi4zMDA0IDEwLjE1NSAyMi4wOTA0IDkuMzU1MDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlightTakeoff = createIcon('FlightTakeoff', [
  [
    'path',
    {
      d: 'M2.52035 18.715H21.5204V20.715H2.52035V18.715ZM22.0904 9.35503C21.8804 8.55503 21.0504 8.07503 20.2504 8.29503L14.9404 9.71503L8.04035 3.28503L6.11035 3.79503L10.2504 10.965L5.28035 12.295L3.31035 10.755L1.86035 11.145L4.45035 15.635C4.45035 15.635 11.5704 13.735 21.0204 11.205C21.8304 10.975 22.3004 10.155 22.0904 9.35503Z',
      key: '107ji0',
    },
  ],
]);

export default FlightTakeoff;
